/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Neighborhood',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path d="M17.189 13.848a1.1 1.1 0 0 1 1.1 1.1v1.589a1.1 1.1 0 0 1-1.1 1.101h-2.468a1.1 1.1 0 0 1-1.1-1.101v-1.589a1.1 1.1 0 0 1 1.1-1.1h2.468zm-2.368 2.589h2.268v-1.39H14.82v1.39zM8.008 8.82a2.191 2.191 0 1 1 0 4.381 2.191 2.191 0 1 1 0-4.381zm0 1.199a.99.99 0 1 0 0 1.981.99.99 0 1 0 0-1.981zm4.69-7.757a.6.6 0 0 1 .831.171.6.6 0 0 1-.172.831l-.758.498v4.75l9.062 3.556a.6.6 0 1 1-.438 1.117l-.715-.281v7.734h.934a.6.6 0 1 1 0 1.2H2.557a.6.6 0 1 1 0-1.2h.859V9.808l-.529.349a.6.6 0 0 1-.66-1.002L12.6 2.326l.099-.064zM12.6 20.614h6.709v-8.182L12.6 9.8v10.814zM4.615 9.019v11.595h1.413v-4.371a1.1 1.1 0 0 1 1.1-1.1h1.787a1.1 1.1 0 0 1 1.1 1.1v4.371H11.4V4.553L4.615 9.019zm2.612 11.595h1.587v-4.271H7.228v4.272z" />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
